import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import DashboardContent from '../pages/dashboard/components/DashboardContent';
import PartnerProfile from '../pages/dashboard/components/PartnerProfile';
import PaymentInfo from '../pages/dashboard/components/PaymentInfo';
import UserProfile from '../pages/dashboard/components/UserProfile';
import { dashboardRoutes } from './dashboardRoutes';
import { landingPageRoutes } from './landingPageRoutes';
import { useDispatch } from 'react-redux';
import ProtectedRoute from './ProtectedComponent';
import Logout from '../components/Authentication/Logout';
import { getLocation } from 'redux/actions/profileActions';
import PerformanceEarning from 'pages/dashboard/components/PerformanceEarning';
import OAuthCallback from 'pages/OAuthCallback';

const AllRoutes = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = window.localStorage.getItem('token');
        // eslint-disable-next-line no-unused-vars
        // const refresh_token = window.localStorage.getItem('refresh_token');
        //if token exists
        if (!token) {
            <Navigate to="/login" />;
        }
        dispatch(getLocation());
    }, [dispatch]);

    useEffect(() => {
        if (navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister();
                }
            });
        }
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                {/* Landing and auth page routes */}
                {landingPageRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={route.element} />
                ))}
                {/* Protected Routing */}
                <Route path="/oauth-success" element={<OAuthCallback />} />
                <Route exact path="/" element={<ProtectedRoute />}>
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/dashboard" element={<Dashboard />}>
                        <Route path="/dashboard">
                            <Route index element={<DashboardContent />} />
                            {dashboardRoutes.map((route) => (
                                <Route key={route.path} path={route.path} element={route.element} />
                            ))}
                            <Route path="profile">
                                <Route path="partner" element={<PartnerProfile />} />
                                <Route path="user" element={<UserProfile />} />
                                <Route path="paymentinfo" element={<PaymentInfo />} />
                                <Route path="performance" element={<PerformanceEarning />} />
                            </Route>
                        </Route>
                    </Route>{' '}
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AllRoutes;
